import { render, staticRenderFns } from "./EditorNavbar.vue?vue&type=template&id=0827e665&scoped=true"
import script from "./EditorNavbar.vue?vue&type=script&lang=js"
export * from "./EditorNavbar.vue?vue&type=script&lang=js"
import style0 from "./EditorNavbar.vue?vue&type=style&index=0&id=0827e665&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0827e665",
  null
  
)

export default component.exports